module.exports = __webpack_public_path__ + "static/media/12UNCTAD15.3f43edcd.jpg";